import { GetConditionalValuePipe } from './getConditionalValue.pipe';
import { NgModule } from '@angular/core';
import { CurrencyFormat } from './currency.pipe';
import { CpfFormat } from './cpf.pipe';
import { CnpjFormat } from './cnpj.pipe';
import { CepFormat } from './cep.pipe';

@NgModule({
  declarations: [
    CurrencyFormat,
    CpfFormat,
    CnpjFormat,
    CepFormat,
    GetConditionalValuePipe,
  ],
  exports: [
    CurrencyFormat,
    CpfFormat,
    CnpjFormat,
    CepFormat,
    GetConditionalValuePipe,
  ]
})
export class PipesModule { }
